import { Receivable } from '@/types/finance/receivable';
import dayjs from 'dayjs';

const receivableTypes: Array<'rent' | 'maintenance' | 'utility' | 'fine' | 'other'> = ['rent', 'maintenance', 'utility', 'fine', 'other'];
const receivableStatuses: Array<'pending' | 'partial' | 'paid' | 'overdue' | 'cancelled'> = ['pending', 'partial', 'paid', 'overdue', 'cancelled'];
const residentNames = [
  'John Doe', 'Jane Smith', 'Mike Johnson', 'Sarah Wilson', 'David Brown',
  'Lisa Davis', 'Robert Miller', 'Jennifer Garcia', 'William Rodriguez', 'Maria Martinez',
  'James Anderson', 'Patricia Taylor', 'John Thomas', 'Linda Jackson', 'Michael White',
  'Barbara Harris', 'Richard Martin', 'Elizabeth Thompson', 'Joseph Garcia', 'Jennifer Martinez'
];

const amounts = [1200, 1500, 1800, 2000, 2200, 2500, 2800, 3000, 3500, 4000];

export const receivables: Receivable[] = Array.from({ length: 50 }, (_, idx) => {
  const typeIndex = idx % receivableTypes.length;
  const statusIndex = idx % receivableStatuses.length;
  const residentIndex = idx % residentNames.length;
  const amountIndex = idx % amounts.length;
  
  const dueDate = dayjs().add(Math.floor(Math.random() * 30), 'days').toDate();
  const createdAt = dayjs().subtract(Math.floor(Math.random() * 60), 'days').toDate();
  const paidAt = receivableStatuses[statusIndex] === 'paid' ? dayjs().subtract(Math.floor(Math.random() * 30), 'days').toDate() : undefined;
  
  return {
    id: `REC${(idx + 1).toString().padStart(3, '0')}`,
    name: `${receivableTypes[typeIndex]} - ${residentNames[residentIndex]}`,
    description: `${receivableTypes[typeIndex]} payment for ${residentNames[residentIndex]}`,
    amount: {
      amount: amounts[amountIndex] + Math.floor(Math.random() * 500),
      currency: 'USD'
    },
    type: receivableTypes[typeIndex],
    status: receivableStatuses[statusIndex],
    dueDate,
    paidAt,
    resident: {
      id: `RES${(residentIndex + 1).toString().padStart(3, '0')}`,
      name: residentNames[residentIndex]
    },
    workspace: {
      id: 'demo-workspace',
      name: 'Sunset Gardens',
      slug: 'demo-workspace'
    },
    createdAt,
    updatedAt: paidAt || createdAt,
    activityRecords: [
      {
        timestamp: createdAt,
        type: 'created',
        performedBy: { id: 'ADM001', displayName: 'Admin User' }
      },
      ...(paidAt ? [{
        timestamp: paidAt,
        type: 'updated' as const,
        performedBy: { id: 'ADM001', displayName: 'Admin User' },
        details: 'Payment received'
      }] : [])
    ]
  };
}); 